import './index.scss';

const blockTextColumn = () => {
	
};

export default blockTextColumn;
